import React from "react";

const NeccTelecomInner = () => {
  return (
    <>
      {/* Start Services area  */}
      <div className='service-area pd-top-45 pd-bottom-45 '>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-11 align-self-center'>
                <div className='about-inner-wrap'>
                  <div className='section-title mb-0'>
                  <span className='subtitles'>NECC TELECOM</span>
                <h2 className='title'>Up-to-date Logistics for Competitive Telecom Sector</h2>
             
                  <p className='content'>
                  A Subsidiary of North Eastern Carrying Corporation, ‘NECC Telecom’ specializes in providing customized logistics to telecom industry. Adhering rigidly to the practices specific to the sector on global level, we offer seamless end to end supply chain services.
                    </p>
          
                <p className='content'>
                As competitive Telecom Industry requires highly efficient and customized logistics solutions, we have latest systems and processes in place that help us maintain high service standard in line with the requirement of clients.
                </p>
                <p className='content'>
                We have ready to use assets/platforms on pan-India basis through which we provide integrated logistics solutions to telecom leaders like ERICSSON, DIESL, NEC, VODAFONE, ZTE, CERAGON and many others.
                </p>
          <h4 style={{marginTop:"20px",marginBottom:"20px"}}>Salient Attributes of our Telecom logistics</h4>
                <div className='row'>
                      <div className='col-xl-6 col-lg-12 col-md-6'>
                        <ul className='list-inner-wrap mb-mb-0 mb-3 mb-lg-3 mb-xl-0'>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />{" "}
                          Integrated Telecom Logistics Solutions
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                           Cargo Inspection
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Pick & Pack
                          </li>
                          <li>
                            <img
                              src='./assets/img/icon/check.png'
                              alt='Transpro'
                            />
                            Warehousing, Secondary Transportation and Distribution
                          </li>
                        </ul>
                      </div>
                    </div>
                 </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      {/* End Services area  */}
    </>
  );
};

export default NeccTelecomInner;
